import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import moment from 'moment-timezone';
import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';

class MemberBookedSessionModal extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    session: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired,
  };

  state = {
    canceling: false,
  };

  toggleCanceling = () => {
    this.setState(state => ({ canceling: !state.canceling }));
  };

  renderTathataInfo() {
    const { session } = this.props;
    return (
      <div>
        <div className="booking-modal--header">
          <Icon icon="Tathata-Logo" />
          <h3>Follow-Up</h3>
        </div>
        <div>
          {session.note && (
            <div className="booking-note">
              <i>"{session.note}"</i>
            </div>
          )}
          <div className="session-info">
            <div className="session-info__item">
              <Icon icon="Check" />
              Tathata Golf
            </div>
            <div className="session-info__item">
              <Icon icon="Calendar" />
              <div>
                <strong>
                  {moment(session.accepted_session_date)
                    .tz(session.time_zone_id)
                    .format('MMM D, YYYY | h:mmA z')}
                </strong>
              </div>
            </div>
            <div className="session-info__address">
              <Icon icon="MapMarker" />
              <p>{session.type}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderMovementSpecialistInfo() {
    const { session } = this.props;
    return (
      <div>
        <h3>Follow-Up</h3>
        <div
          style={{
            backgroundImage: `url(${get(
              session,
              'movementSpecialist.movementSpecialistProfile.profileImage.location'
            )})`,
          }}
          className="ms__request-img"
        />
        <h4>{get(session, 'movementSpecialist.movementSpecialistProfile.name')}</h4>
        {session.note && (
          <div className="booking-note">
            <i>"{session.note}"</i>
          </div>
        )}
        <div>
          <div className="session-info">
            <div className="session-info__item">
              <Icon icon="Calendar" />
              <div>
                <strong>
                  {moment(session.accepted_session_date)
                    .tz(session.time_zone_id)
                    .format('MMM D, YYYY | h:mmA z')}
                </strong>
              </div>
            </div>
            <div className="session-info__address">
              <Icon icon="MapMarker" />
              <p>{get(session, 'movementSpecialist.movementSpecialistProfile.location_long')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, onCancel, session, toggleModal } = this.props;
    const { canceling } = this.state;

    if (loading) {
      return <Loading />;
    }

    if (canceling) {
      return (
        <div>
          <div className="booking-modal">
            <button className="close-button" onClick={toggleModal}>
              <Icon icon="Close" />
            </button>
            <h3>Cancel Follow-Up</h3>
            <div>A refund will show up on your account within a few days.</div>
          </div>
          <div className="modal__actions">
            <button className="button button--theme--plain" type="button" onClick={this.toggleCanceling}>
              Go Back
            </button>
            <button className="button" type="button" onClick={onCancel}>
              Confirm
            </button>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="booking-modal">
          <button className="close-button" onClick={toggleModal}>
            <Icon icon="Close" />
          </button>
          {session.type === 'movement-specialist' ? this.renderMovementSpecialistInfo() : this.renderTathataInfo()}
        </div>
        {moment(session.accepted_session_date)
          .tz(session.time_zone_id)
          .isAfter(
            moment()
              .tz(session.time_zone_id)
              .add(1, 'day')
          ) && (
          <div className="modal__actions">
            <div>
              <button type="button" className="button button--theme--secondary" onClick={this.toggleCanceling}>
                Cancel Follow-Up
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MemberBookedSessionModal;



// WEBPACK FOOTER //
// ./src/subscription/sessions/MemberBookedSessionModal.js